module.exports = __webpack_public_path__ + "assets/img/404_error.2d426589.webp";